// Resolve a tenant-branding asset (hero image, logo) to an absolute URL.
// Uploaded files come back as relative "/api/..." paths (served by the
// backend); free-typed external URLs (http/https) are returned as-is.
export const resolveAssetUrl = (url) => {
  if (!url) return url;
  if (url.startsWith('/')) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};
